import React from "react";
import { styled } from "styled-components";

const WhatWeDoItems = ({
  title,
  ImageIcon,
  description,
  index = 0,
}: {
  title: string;
  ImageIcon: any;
  description: string;
  index?: number;
}) => {
  return (
    <StyledItems>
      <div className="itemNumber">0{index + 1}</div>
      <div className="itemContent">
        <div className="itemHeader">
          <div className="iconWrapper">
            <ImageIcon className="icon" />
          </div>
          <h3>{title}</h3>
        </div>
        <p>{description}</p>
      </div>
      <div className="itemArrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M7 17l9.2-9.2M17 17V7H7" />
        </svg>
      </div>
    </StyledItems>
  );
};

export default WhatWeDoItems;

export const StyledItems = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 28px 32px;
  background: var(--card-bg);
  border-radius: 20px;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
  will-change: transform, opacity;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 0;
    background: linear-gradient(180deg, var(--accent) 0%, var(--primary) 100%);
    transition: height 0.4s ease;
  }

  &:hover {
    border-color: var(--card-border);
    transform: translateX(10px);
    box-shadow: 0 20px 50px var(--shadow-medium);

    &::before {
      height: 100%;
    }

    .itemArrow {
      opacity: 1;
      transform: translate(0, 0);
    }

    .itemNumber {
      color: var(--accent);
    }
  }

  .itemNumber {
    font-family: Poppins;
    font-size: 48px;
    font-weight: 800;
    color: var(--bg-tertiary);
    line-height: 1;
    transition: color 0.4s ease;
    flex-shrink: 0;
    min-width: 70px;
  }

  .itemContent {
    flex: 1;

    .itemHeader {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 12px;

      .iconWrapper {
        width: 48px;
        height: 48px;
        border-radius: 14px;
        background: linear-gradient(135deg, rgba(217, 58, 53, 0.15) 0%, rgba(217, 58, 53, 0.05) 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        .icon {
          color: var(--accent);
          width: 24px;
          height: 24px;
        }
      }

      h3 {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
      }
    }

    p {
      font-family: Poppins;
      font-size: 15px;
      line-height: 1.7;
      color: var(--text-secondary);
      margin: 0;
      padding-left: 64px;
    }
  }

  .itemArrow {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: var(--bg-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    opacity: 0;
    transform: translate(-10px, 10px);
    transition: all 0.4s ease;

    svg {
      width: 20px;
      height: 20px;
      color: var(--primary);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    gap: 16px;

    .itemNumber {
      font-size: 36px;
      min-width: auto;
    }

    .itemContent {
      .itemHeader {
        gap: 12px;
      }

      p {
        padding-left: 0;
        margin-top: 8px;
      }
    }

    .itemArrow {
      display: none;
    }
  }
`;
